<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="input">
    <v-layout row>
      <v-flex xs5 class="ma-1 pa-2">
        <v-checkbox
          label="Senior"
          v-model="passenger.discounts[1].value"
          @change="parentSave(1, passenger.discounts[1].value)"
        ></v-checkbox>
      </v-flex>
      <v-flex class="ma-1 pa-2 ml-2 pl-2">
        <v-checkbox
          label="Student"
          v-model="passenger.discounts[0].value"
          @change="parentSave(0, passenger.discounts[0].value)"
        ></v-checkbox>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Shared from "@/mixins/Shared";

export default {
  name: "AddPassengerDiscounts",
  props: {
    passenger: {
      type: Object,
      required: true
		},
    saveDiscount: {
      type: Function
    }
  },
  methods: {
    parentSave(index, val) {
      const oIndex = index === 0 ? 1 : 0;
      if (val === true && this.passenger.discounts[oIndex].value === true) {
        // eslint-disable-next-line vue/no-mutating-props
        this.passenger.discounts[oIndex].value = false;
      }
      this.saveDiscount(this.passenger);
			this.form_fields.agree_to_terms = false;
      this.testCompleteStep(this.getFormIndexByPath('/summary'));
    }
  },
  mixins: [Shared]
};
</script>
